module.exports = __webpack_public_path__ + "static/media/search_retooling.d7bd2100.png";